import { config } from "@financial-advisory/config";
import { useAppSelector } from "../hooks";
import type { AuthState } from "@unlikelyai-magic/shared/data-access/api";

export type StateWithAuth = { auth: AuthState };

/**
 * Returns whether the currently logged in user should see the Uncheck UI.
 */
export function isUncheckUser(state: StateWithAuth) {
  const tenantId = state.auth.tenantId;
  return tenantId === config.UNCHECK_ORGANISATION_ID;
}

/**
 * Returns whether the currently logged in user should see the Uncheck UI.
 */
export function useUiSwitcher() {
  const tenantId = useAppSelector(({ auth }) => auth.tenantId);
  return tenantId === config.UNCHECK_ORGANISATION_ID;
}
